<template>
  <div class="payment-create main-content">
    <div class="page-header">
      <h3 class="page-title">
        {{ $t("pos.purchase_order_prepayment_offer") }}
      </h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link
            v-if="userType == 'super_admin'"
            slot="item-title"
            to="/super-admin/dashboard"
            >{{ $t("general.home") }}</router-link
          >
          <router-link
            v-else-if="userType == 'supplier'"
            slot="item-title"
            to="/supplier/dashboard"
            >{{ $t("general.home") }}</router-link
          >
          <router-link
            v-else-if="userType == 'anchor'"
            slot="item-title"
            to="/anchor/dashboard"
            >{{ $t("general.home") }}</router-link
          >
          <router-link
            v-else-if="userType == 'funder'"
            slot="item-title"
            to="/funder/dashboard"
            >{{ $t("general.home") }}</router-link
          >
        </li>
        <li class="breadcrumb-item">
          <router-link
            v-if="userType == 'super_admin'"
            slot="item-title"
            to="/super-admin/invoices"
            >{{ $tc("invoices.invoice", 2) }}</router-link
          >
          <router-link
            v-else-if="userType == 'supplier'"
            slot="item-title"
            to="/supplier/purchase-orders"
            >{{ $tc("navigation.pos", 2) }}</router-link
          >
          <router-link
            v-else-if="userType == 'anchor'"
            slot="item-title"
            to="/anchor/invoices"
            >{{ $tc("invoices.invoice", 2) }}</router-link
          >
          <router-link
            v-else-if="userType == 'funder'"
            slot="item-title"
            to="/funder/purchaseorder-financing"
            >{{ $tc("navigation.po_financing") }}</router-link
          >
        </li>
        <li class="breadcrumb-item">
          {{ $t("pos.purchase_order_prepayment_offer") }}
        </li>
      </ol>
      <!-- v-if="userType == 'supplier' && invoiceData.status == 'OFFERED'" -->
      <div
        v-if="userType == 'supplier' && invoiceData.status == 'OFFERED'"
        class="page-actions row"
      >
        <div class="col-xs-2 mr-4">
          <time-counter
            :start-at="{
              date: offerStartAt
            }"
            :end-at="{
              date: offerEndAt
            }"
          />
        </div>
        <div
          v-if="!isExpired"
          class="d-flex align-items-center justify-content-end gap-2"
        >
          <div class="col-xs-2 mr-4">
            <base-button
              v-if="isRejectedButtonShow"
              :loading="isLoading"
              :disabled="isLoading"
              :outline="true"
              size="large"
              icon="times"
              color="theme"
              @click="onRejectedLoan()"
            >
              {{ $t("general.reject") }}
            </base-button>
          </div>
          <div class="col-xs-2">
            <base-button
              v-if="isFinancedButtonShow"
              :loading="isLoading"
              :disabled="isLoading"
              size="large"
              icon="check"
              color="theme"
              @click="onFinancedLoan()"
            >
              {{ $t("general.accept") }}
            </base-button>
          </div>
        </div>
      </div>
    </div>

    <SinglePurchaseOrderFinanceRow :fetch-data="fetchData" />

    <SinglePrePaymentPOFinanceRequestRow
      :prepayment-request="prepaymentRequest"
    />
  </div>
</template>

<script>
import SinglePurchaseOrderFinanceRow from "./SinglePurchaseOrderFinanceRow.vue";
import SinglePrePaymentPOFinanceRequestRow from "./SinglePrePaymentPOFinanceRequestRow.vue";
import Attachment from "./Attachment";
import { mapActions, mapGetters } from "vuex";
import MultiSelect from "vue-multiselect";
import { validationMixin } from "vuelidate";
import moment from "moment";
const {
  required,
  between,
  maxLength,
  numeric
} = require("vuelidate/lib/validators");

export default {
  components: {
    MultiSelect,
    Attachment,
    SinglePrePaymentPOFinanceRequestRow,
    SinglePurchaseOrderFinanceRow
  },
  mixins: [validationMixin],
  data() {
    return {
      userType: null,
      fetchData: [],
      isLoading: false,
      isFinancedButtonShow: true,
      isRejectedButtonShow: true,
      prepaymentRequest: [],
      invoiceData: {
        request_level: null
      },
      offerStartAt: null,
      offerEndAt: null,
      isExpired: true
    };
  },
  computed: {},
  watch: {},
  created() {
    if (localStorage.getItem("role") == "super_admin") {
      this.userType = "super_admin";
    } else if (localStorage.getItem("account_type") == "anchor") {
      this.userType = "anchor";
    } else if (localStorage.getItem("account_type") == "funder") {
      this.userType = "funder";
    } else if (localStorage.getItem("account_type") == "supplier") {
      this.userType = "supplier";
    }
    this.setInvoiceData();
    this.loadInvoice();
    this.loadRequest();
  },
  validations() {
    return {};
  },
  async mounted() {
    this.checkExpiration();
    this.interval = setInterval(this.checkExpiration, 1000);
    this.$nextTick(() => {});
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    ...mapActions("po", ["SinglePOArray", "fetchPurchaseOrderShow"]),
    ...mapActions("prepayment", ["fetchPOPrePaymentRequest"]),
    ...mapActions("modal", ["openModal"]),
    ...mapActions("LoanRequest", ["poLoanRequestStatus"]),
    async setInvoiceData() {
      let data = await this.fetchPurchaseOrderShow(this.$route.params.id);
      this.invoiceData = data.data.purchaseOrder;
    },
    async loadInvoice() {
      if (this.$route.params.id) {
        let response = await this.SinglePOArray(this.$route.params.id);
        if (response.data) {
          this.fetchData = response.data.purchaseOrder;
        }
      }
    },
    async loadRequest() {
      if (this.$route.params.id) {
        let res = await this.fetchPOPrePaymentRequest(this.$route.params.id);
        if (res.data) {
          this.prepaymentRequest = res.data.pOPrepaymentRequest;
          this.offerEndAt = res.data.pOPrepaymentRequest[0].offer_expire;
          // console.log("offerEndAt ", this.offerEndAt);
          this.offerStartAt = moment().utcOffset();
          console.log("expires ", this.offerEndAt, this.offerStartAt);
        }
      }
    },

    checkExpiration() {
      const expireDate = moment(this.offerEndAt);
      const currentDate = moment();
      this.isExpired = expireDate.isSameOrBefore(currentDate);
      // console.log(
      //   "this.isExpired",
      //   this.offerEndAt,
      //   this.isExpired,
      //   expireDate.format(),
      //   currentDate.format(),
      //   expireDate.isSameOrBefore(currentDate)
      // );
    },

    async onRejectedLoan() {
      const data = {
        purchase_order_id: this.$route.params.id,
        status: "REJECTED"
      };
      this.isFinancedButtonShow = false;
      this.isLoading = true;
      let response = await this.poLoanRequestStatus(data);
      if (response.data.success) {
        this.isLoading = false;
        window.toastr["success"](this.$tc("prepayments.offer_reject_message"));
        this.$router.push("/supplier/purchase-orders");
        return true;
      }
      if (response.data.error) {
        this.isLoading = false;
        window.toastr["error"](response.data.message);
        this.$router.push("/supplier/purchase-orders");
      }
    },
    async onFinancedLoan() {
      const data = {
        purchase_order_id: this.$route.params.id,
        status: "FINANCED"
      };
      this.isLoading = true;
      this.isRejectedButtonShow = false;
      let response = await this.poLoanRequestStatus(data);
      if (response.data.success) {
        this.isLoading = false;
        window.toastr["success"](this.$tc("prepayments.offer_accept_message"));
        this.$router.push("/supplier/purchase-orders");
        return true;
      }
      if (response.data.error) {
        this.isLoading = false;
        window.toastr["error"](response.data.message);
        this.$router.push("/supplier/purchase-orders");
      }
    }
  }
};
</script>
<style scoped>
.table-component {
  min-height: 0px;
}
</style>
